/* AQUON PDP Bundle - variant selectors, gallery, bundle picker, add-to-cart. */
(function () {
  'use strict';

  function moneyFormat(cents) {
    var format = window.Shopify && Shopify.currency && Shopify.currency.money_format;
    var value = (cents / 100).toFixed(2);
    if (format) {
      // Basic replacement for common Shopify money formats
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, String(Math.round(cents / 100)));
    }
    return '₹' + value;
  }

  function svgPlus() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }
  function svgMinus() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  // Collapse the thumbnail column to the first N items on desktop, with a
  // thumbnail-styled +/- toggle that reveals the rest and lets the column scroll
  // internally (its height capped to the main image). No-op on mobile (the
  // horizontal scroller) and when there is nothing to collapse. Idempotent, so
  // it is safe to re-run after the thumbs are rebuilt on a flavour swap.
  function setupThumbExpand(sec) {
    var thumbsEl = sec.querySelector('[data-apdp-thumbs]') || sec.querySelector('.apdp__thumbs');
    if (!thumbsEl) return;
    var expandable = thumbsEl.getAttribute('data-expandable') !== 'false';
    var initial = parseInt(thumbsEl.getAttribute('data-initial'), 10);
    if (isNaN(initial) || initial < 1) initial = 6;
    var galleryEl = sec.querySelector('.apdp__gallery');
    var mq = window.matchMedia('(min-width: 750px)');
    var ro = null;

    function cap() {
      if (galleryEl) thumbsEl.style.maxHeight = Math.round(galleryEl.getBoundingClientRect().height) + 'px';
    }

    function apply() {
      // Clean slate so re-runs (rebuild, breakpoint change) never stack state.
      var old = thumbsEl.querySelector('[data-apdp-thumb-toggle]');
      if (old) old.remove();
      var thumbs = Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-apdp-thumb]'));
      thumbs.forEach(function (t) { t.classList.remove('apdp__thumb--overflow'); });
      thumbsEl.classList.remove('is-collapsible');
      thumbsEl.classList.remove('is-expanded');
      thumbsEl.style.maxHeight = '';
      // Hand the wheel back to Lenis when this isn't a live scroll area.
      thumbsEl.removeAttribute('data-scrollable');
      if (ro) { ro.disconnect(); ro = null; }

      // Nothing to do: disabled, on mobile, or few enough to show in full.
      if (!expandable || !mq.matches || thumbs.length <= initial) return;

      thumbsEl.classList.add('is-collapsible');
      // The theme's Lenis smooth-scroll prevents native scrolling on nested
      // elements unless they match LENIS_PREVENT_SELECTOR (utilities.js). Marking
      // the column [data-scrollable] lets the wheel scroll the thumbs, not the page.
      thumbsEl.setAttribute('data-scrollable', '');
      cap();
      thumbs.forEach(function (t, i) { if (i >= initial) t.classList.add('apdp__thumb--overflow'); });

      var hiddenCount = thumbs.length - initial;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'apdp__thumb-toggle';
      toggle.setAttribute('data-apdp-thumb-toggle', '');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Show ' + hiddenCount + ' more image' + (hiddenCount === 1 ? '' : 's'));
      toggle.innerHTML = svgPlus();
      // Collapsed, the + sits right after the Nth thumbnail. Expanded, the -
      // moves to the very bottom, after the last thumbnail (not swapped in place).
      var anchor = thumbs[initial - 1];
      function placeCollapsed() {
        if (anchor && anchor.nextSibling) thumbsEl.insertBefore(toggle, anchor.nextSibling);
        else thumbsEl.appendChild(toggle);
      }
      placeCollapsed();

      toggle.addEventListener('click', function () {
        var expanded = thumbsEl.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.innerHTML = expanded ? svgMinus() : svgPlus();
        toggle.setAttribute('aria-label', expanded
          ? 'Show fewer images'
          : ('Show ' + hiddenCount + ' more image' + (hiddenCount === 1 ? '' : 's')));
        if (expanded) {
          thumbsEl.appendChild(toggle);
        } else {
          placeCollapsed();
          thumbsEl.scrollTop = 0;
        }
      });

      if (galleryEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () { cap(); });
        ro.observe(galleryEl);
      }
    }

    apply();
    var onChange = function () { apply(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Let rebuildThumbs() re-collapse the fresh thumbs after a flavour swap.
    thumbsEl._apdpApplyExpand = apply;
  }

  function initSection(sec) {
    if (!sec || sec.dataset.apdpInit === '1') return;
    sec.dataset.apdpInit = '1';

    var variantsScript = sec.querySelector('[data-apdp-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) {}
    }

    var mainImg = sec.querySelector('[data-apdp-main]');
    var priceEl = sec.querySelector('[data-apdp-price]');
    var compareEl = sec.querySelector('[data-apdp-compare]');
    var cta = sec.querySelector('[data-apdp-atc]');
    var toast = sec.querySelector('[data-apdp-toast]');
    var toastTimer = null;

    // Track option selections by index
    var optionGroups = sec.querySelectorAll('[data-apdp-option-group]');
    var selectedOptions = {};
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var activeBtn = group.querySelector('.is-active[data-value]');
      if (activeBtn) selectedOptions[idx] = activeBtn.getAttribute('data-value');
    });
    // Sync price/image to the active pill on init (in case merchant hid the default pack)
    setTimeout(function () {
      var v0 = findMatchingVariant();
      if (v0) updateFromVariant(v0);
    }, 0);

    function findMatchingVariant() {
      if (!variants.length) return null;
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (idxKey) {
          var idx = parseInt(idxKey, 10);
          return v.options[idx] === selectedOptions[idxKey];
        });
      }) || null;
    }

    function updateFromVariant(v) {
      if (!v) return;
      if (cta) {
        cta.setAttribute('data-variant-id', v.id);
        cta.disabled = !v.available;
        var span = cta.querySelector('.apdp__cta-text');
        if (span) span.textContent = v.available ? (cta.dataset.originalLabel || span.textContent) : 'Sold out';
      }
      if (priceEl) priceEl.textContent = moneyFormat(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = moneyFormat(v.compare_at_price);
        } else {
          compareEl.textContent = '';
        }
      }
      var badgeEl = sec.querySelector('[data-apdp-badge]');
      if (badgeEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          badgeEl.textContent = pct + '% OFF';
          badgeEl.hidden = false;
        } else {
          badgeEl.textContent = '';
          badgeEl.hidden = true;
        }
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.classList.remove('is-cover');
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = v.featured_image.src;
          mainImg.classList.remove('is-fading');
        }, 150);
      }
    }

    // Option button clicks
    sec.querySelectorAll('[data-apdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-apdp-option'), 10);
        var val = btn.getAttribute('data-value');
        selectedOptions[idx] = val;

        // Toggle active class in the same group
        var group = btn.closest('[data-apdp-option-group]');
        if (group) {
          group.querySelectorAll('[data-apdp-option]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          var valueLabel = sec.querySelector('[data-apdp-option-value="' + idx + '"]');
          if (valueLabel) valueLabel.textContent = val;
        }

        // If a flavor button carries its own image, update immediately
        var overrideSrc = btn.getAttribute('data-image-src');
        if (overrideSrc && mainImg) {
          mainImg.classList.remove('is-cover');
          mainImg.classList.add('is-fading');
          setTimeout(function () {
            mainImg.src = overrideSrc;
            mainImg.classList.remove('is-fading');
          }, 150);
        }

        var v = findMatchingVariant();
        if (v) updateFromVariant(v);
      });
    });

    // Flavor product tile clicks - swap in place instead of navigating
    var titleEl = sec.querySelector('[data-apdp-title]');
    var descEl = sec.querySelector('[data-apdp-desc]');
    var flavorValueEl = sec.querySelector('[data-apdp-flavor-value]');
    var thumbsEl = sec.querySelector('.apdp__thumbs');

    function normalizeImg(url, size) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = window.location.protocol + url;
      if (size) url = url.replace(/(_\d+x\d*|_\d+x)(?=\.(jpg|jpeg|png|webp))/i, '_' + size);
      return url;
    }

    // Swap the bundle-card images to the given flavour's per-pack images. The URLs
    // travel on each flavour tile as data-bundle-img-1/2/3 (from the flavour
    // variant's metafields), so this needs no network request. Each card carries
    // data-pack (1/2/3) to pick its matching image. We preload then swap so there
    // is no flash, and the card image box keeps fixed dimensions (no layout shift).
    // If a flavour has no bundle metafields, its cards keep the static image.
    function updateBundleImages(flavorEl) {
      if (!flavorEl) return;
      var byPack = {
        '1': flavorEl.getAttribute('data-bundle-img-1'),
        '2': flavorEl.getAttribute('data-bundle-img-2'),
        '3': flavorEl.getAttribute('data-bundle-img-3')
      };
      sec.querySelectorAll('[data-apdp-bundle-img]').forEach(function (img) {
        var url = byPack[img.getAttribute('data-pack') || '1'];
        if (!url || img.getAttribute('src') === url) return;
        var pre = new Image();
        pre.onload = function () { img.src = url; img.removeAttribute('srcset'); };
        pre.src = url;
      });
    }

    function rebuildThumbs(prod) {
      if (!thumbsEl) return;
      var imgs = prod.images || [];
      if (!imgs.length) return;
      thumbsEl.innerHTML = '';
      imgs.forEach(function (raw, i) {
        var full = normalizeImg(raw, '1200x');
        var small = normalizeImg(raw, '200x');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'apdp__thumb' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('data-apdp-thumb', '');
        btn.setAttribute('data-index', String(i));
        btn.setAttribute('data-image-src', full);
        btn.setAttribute('aria-label', 'Show image ' + (i + 1));
        var img = document.createElement('img');
        img.className = 'apdp__thumb-img';
        img.loading = 'lazy';
        img.src = small;
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          thumbsEl.querySelectorAll('[data-apdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (!mainImg) return;
          mainImg.classList.toggle('is-cover', i > 0);
          var b = sec.querySelector('[data-apdp-badge]');
          if (b) b.hidden = i > 0 || !b.textContent.trim();
          if (galleryEl) galleryEl.classList.toggle('is-first-image', i === 0);
          mainImg.classList.add('is-fading');
          setTimeout(function () {
            mainImg.src = full;
            mainImg.srcset = '';
            mainImg.classList.remove('is-fading');
          }, 150);
        });
        thumbsEl.appendChild(btn);
      });
      // Re-collapse the fresh thumbs behind the +/- toggle (desktop).
      if (thumbsEl._apdpApplyExpand) thumbsEl._apdpApplyExpand();
    }

    sec.querySelectorAll('[data-apdp-flavor]').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = tile.getAttribute('data-flavor-handle');
        if (!handle) return;
        var url = tile.getAttribute('data-flavor-url') || ('/products/' + handle);

        // Mark active tile immediately
        sec.querySelectorAll('[data-apdp-flavor]').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-checked', 'false');
        });
        tile.classList.add('is-active');
        tile.setAttribute('aria-checked', 'true');

        // Swap the bundle-card images to this flavour instantly (no wait on fetch).
        updateBundleImages(tile);

        var flavorName = tile.getAttribute('data-flavor-name') || '';
        if (flavorValueEl) flavorValueEl.textContent = flavorName;

        fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (prod) {
            if (!prod) return;

            if (titleEl) titleEl.textContent = prod.title || flavorName;
            if (descEl) descEl.innerHTML = prod.description || '';

            var firstAvail = (prod.variants || []).find(function (v) { return v.available; }) || prod.variants[0];
            if (firstAvail) {
              if (priceEl) priceEl.textContent = moneyFormat(firstAvail.price);
              if (compareEl) {
                compareEl.textContent = (firstAvail.compare_at_price && firstAvail.compare_at_price > firstAvail.price)
                  ? moneyFormat(firstAvail.compare_at_price) : '';
              }
              if (cta) cta.setAttribute('data-variant-id', firstAvail.id);
            }
            // Keep the flavour NAME in step with the variant id above. Without
            // this the single-pick add-to-cart path kept labelling the cart line
            // with the flavour the page originally loaded with.
            if (cta) cta.setAttribute('data-product-title', prod.title || flavorName);

            // Repaint the Judge.me badge for the flavour now on screen, so the
            // stars are never the previous flavour's. batchRenderBadges takes a
            // list of {productHandle, badgePlaceholder}; the app also stamps
            // `jdgm--done-setup` on a badge it has already built, which has to
            // come off or it skips the re-render. The badge is emptied first:
            // a blank row for a moment beats showing another product's rating,
            // and .apdp__reviews reserves the height so nothing shifts.
            var jdgmBadge = sec.querySelector('[data-apdp-jdgm]');
            if (jdgmBadge && prod.id && String(jdgmBadge.getAttribute('data-id')) !== String(prod.id)) {
              jdgmBadge.setAttribute('data-id', prod.id);
              jdgmBadge.innerHTML = '';
              jdgmBadge.classList.remove('jdgm--done-setup');
              if (window.jdgm && typeof window.jdgm.batchRenderBadges === 'function') {
                try {
                  window.jdgm.batchRenderBadges([{ productHandle: handle, badgePlaceholder: jdgmBadge }]);
                } catch (e) {}
              }
            }

            var raw = prod.featured_image || (prod.images && prod.images[0]);
            var newImg = null;
            if (raw) {
              newImg = typeof raw === 'string' ? raw : (raw.src || raw.url);
            }
            if (newImg && mainImg) {
              // Normalize protocol-less URL and remove any Shopify size suffix,
              // then request a larger size to match the gallery.
              if (newImg.indexOf('//') === 0) newImg = window.location.protocol + newImg;
              newImg = newImg.replace(/(_\d+x\d*|_\d+x)(?=\.(jpg|jpeg|png|webp))/i, '_1400x');
              mainImg.classList.remove('is-cover');
              mainImg.classList.add('is-fading');
              setTimeout(function () {
                mainImg.src = newImg;
                mainImg.srcset = '';
                mainImg.classList.remove('is-fading');
              }, 150);
            }

            rebuildThumbs(prod);

            // Replace variants JSON so pack pills switch to the new product's variants
            variants = prod.variants || [];
            selectedOptions = {};
            if (firstAvail) selectedOptions[0] = firstAvail.options[0];

            // Update browser URL without navigating (optional, for shareability)
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, prod.title, url);
            }
          })
          .catch(function () { /* fail silently, keep current state */ });
      });
    });

    // On load, sync the bundle cards to the active flavour (covers the home /
    // bundle contexts where the section product may differ from the first tile).
    updateBundleImages(sec.querySelector('[data-apdp-flavor].is-active') || sec.querySelector('[data-apdp-flavor]'));

    // Thumbnail clicks
    var galleryEl = sec.querySelector('.apdp__gallery');
    function setBadgeForIndex(index) {
      var b = sec.querySelector('[data-apdp-badge]');
      if (!b) return;
      b.hidden = index > 0 || !b.textContent.trim();
    }
    function setGalleryPaddingForIndex(index) {
      if (galleryEl) galleryEl.classList.toggle('is-first-image', index === 0);
    }
    // Init: first image is active on load.
    setGalleryPaddingForIndex(0);
    sec.querySelectorAll('[data-apdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-image-src');
        if (!src || !mainImg) return;
        sec.querySelectorAll('[data-apdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var idx = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        // 1st image (product cutout) shows contained; the rest fill the box
        mainImg.classList.toggle('is-cover', idx > 0);
        setBadgeForIndex(idx);
        setGalleryPaddingForIndex(idx);
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = src;
          mainImg.srcset = '';
          mainImg.classList.remove('is-fading');
        }, 150);
      });
    });

    // Collapse the thumbnail column to the first N + a +/- toggle (desktop).
    setupThumbExpand(sec);

    // Gallery prev/next arrows (reuse the thumbnail switching; requery each time
    // so it stays correct after flavor-driven thumb rebuilds).
    var galPrev = sec.querySelector('[data-apdp-gallery-prev]');
    var galNext = sec.querySelector('[data-apdp-gallery-next]');
    function galThumbs() { return Array.prototype.slice.call(sec.querySelectorAll('[data-apdp-thumb]')); }
    function galNav(dir) {
      var thumbs = galThumbs();
      if (thumbs.length < 2) return;
      var active = 0;
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) { active = i; break; } }
      var target = thumbs[(active + dir + thumbs.length) % thumbs.length];
      // If we land on a thumb hidden behind the collapsed gallery, expand first
      // so the newly-active thumbnail is actually visible.
      if (target.classList.contains('apdp__thumb--overflow')) {
        var tgl = sec.querySelector('[data-apdp-thumb-toggle]');
        if (tgl && tgl.getAttribute('aria-expanded') === 'false') tgl.click();
      }
      target.click();
      if (thumbsEl && thumbsEl.classList.contains('is-collapsible')) {
        target.scrollIntoView({ block: 'nearest' });
      }
    }
    function galUpdateNav() {
      var n = galThumbs().length;
      if (galPrev) galPrev.hidden = n < 2;
      if (galNext) galNext.hidden = n < 2;
    }
    if (galPrev) galPrev.addEventListener('click', function () { galNav(-1); });
    if (galNext) galNext.addEventListener('click', function () { galNav(1); });
    galUpdateNav();
    if (thumbsEl && window.MutationObserver) {
      new MutationObserver(galUpdateNav).observe(thumbsEl, { childList: true });
    }

    // Touch swipe on the gallery (mobile) - drag left = next, right = prev.
    // Replaces the arrows that are hidden on phones; reuses galNav().
    var galArea = sec.querySelector('.apdp__main-image') || mainImg;
    if (galArea) {
      var swStartX = 0, swStartY = 0, swActive = false;
      galArea.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swActive = false; return; }
        swStartX = e.touches[0].clientX;
        swStartY = e.touches[0].clientY;
        swActive = true;
      }, { passive: true });
      galArea.addEventListener('touchend', function (e) {
        if (!swActive) return;
        swActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - swStartX;
        var dy = t.clientY - swStartY;
        // Horizontal-dominant swipe only, so vertical page scroll is unaffected.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          galNav(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    // Bundle selection
    var selectedBundle = null;
    var bundleValueLabel = sec.querySelector('[data-apdp-bundle-value]');
    var freebieEls = sec.querySelectorAll('[data-apdp-freebie]');

    function updateFreebies(bundleIndex, bundleQuantity) {
      // Which gift tiles light up is driven entirely by each freebie's
      // `unlock_for` list. Note the 3-pack's free Pack of 24 is NOT a gift line:
      // it is the 4th flavour pick on the bundle line, so the 3-pack only adds
      // the bottle here.
      freebieEls.forEach(function (f) {
        var raw = f.getAttribute('data-unlock-for') || '';
        var list = raw.split(',').map(function (s) { return parseInt(s.trim(), 10); });
        f.classList.toggle('is-disabled', list.indexOf(bundleIndex) === -1);
      });
    }

    var defaultBundleIndex = 0;
    var defaultBundleQuantity = 0;
    sec.querySelectorAll('[data-apdp-bundle]').forEach(function (bundle, i) {
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 0;
      if (i === 0 || bundle.classList.contains('is-selected')) {
        selectedBundle = bundle;
        defaultBundleIndex = i + 1;
        defaultBundleQuantity = qty;
      }
      bundle.addEventListener('click', function () {
        sec.querySelectorAll('[data-apdp-bundle]').forEach(function (b) { b.classList.remove('is-selected'); });
        bundle.classList.add('is-selected');
        selectedBundle = bundle;
        if (bundleValueLabel) bundleValueLabel.textContent = bundle.getAttribute('data-name') || '';
        updateFreebies(i + 1, qty);
        updateCtaLabel(qty);
      });
    });
    if (defaultBundleIndex > 0) updateFreebies(defaultBundleIndex, defaultBundleQuantity);

    // CTA label: "Select Flavor" for multi-pack (2 or 3), "Add to Cart" for 1-pack.
    function updateCtaLabel(quantity) {
      if (!cta) return;
      var label = cta.querySelector('.apdp__cta-text');
      if (!label) return;
      // 1-pack always shows "ADD TO CART"; 2-pack / 3-pack show "SELECT FLAVOR".
      label.textContent = quantity > 1 ? 'SELECT FLAVOR' : 'ADD TO CART';
    }
    updateCtaLabel(defaultBundleQuantity);

    // Confirmation state after a successful add. The sticky bar mirrors this
    // button's label and classes, so both surfaces confirm at once - which is
    // the only feedback now that the quick cart no longer opens for sticky adds.
    // Reverts to the CURRENT tier's label, not the one cached at page load, so
    // switching pack mid-flow can't restore the wrong wording.
    var addedTimer = null;
    function showAdded() {
      if (!cta) return;
      var label = cta.querySelector('.apdp__cta-text');
      if (label) label.textContent = 'ADDED ✓';
      cta.classList.add('is-added');
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function () {
        cta.classList.remove('is-added');
        var q = selectedBundle ? (parseInt(selectedBundle.getAttribute('data-quantity'), 10) || 1) : 1;
        updateCtaLabel(q);
      }, 2000);
    }

    // Show toast
    function showToast(msg, isError) {
      if (!toast) return;
      toast.querySelector('.apdp__toast-text').textContent = msg;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 300);
      }, 3200);
    }

    // Scroll reveal: fade + slide the right-column groups up as they enter view,
    // staggering naturally since they are stacked. Gated by .is-reveal-ready so
    // the content stays visible if JS/IO is unavailable or motion is reduced.
    (function setupReveal() {
      var right = sec.querySelector('.apdp__right');
      if (!right || !('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var kids = Array.prototype.slice.call(right.children);
      if (!kids.length) return;
      kids.forEach(function (el) { el.classList.add('apdp__reveal'); });
      sec.classList.add('is-reveal-ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      kids.forEach(function (el) { io.observe(el); });
    })();

    // Flavour picker popup (opens on Add to cart when enabled)
    var flavorModal = sec.querySelector('[data-apdp-flavor-modal]');

    // Which control started the current add-to-cart flow. The sticky bar proxies
    // the main CTA, so the main handler records where the click really came from
    // and the success path uses it: adds started from the sticky bar refresh the
    // cart in place and keep the customer on the PDP, everything else opens the
    // quick cart exactly as before. `flavorFlowOrigin` carries the same answer
    // across the flavour modal, which sits between the click and the add.
    var addOrigin = 'main';
    var flavorFlowOrigin = 'main';

    // Post-add behaviour, shared by the direct and flavour-modal paths.
    function afterAdd(origin) {
      if (origin === 'sticky' && window.AquonCart && window.AquonCart.refresh) {
        window.AquonCart.refresh();
        showToast('Added to cart', false);
      } else if (window.AquonCart && window.AquonCart.open) {
        window.AquonCart.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        showToast('Added to cart', false);
      }
    }

    // How many flavours this tier asks the buyer to pick. Falls back to the
    // tier's cart quantity for bundles configured the old way.
    function flavorPicksFor(bundle) {
      if (!bundle) return 1;
      var picks = parseInt(bundle.getAttribute('data-flavor-picks'), 10);
      if (!isNaN(picks) && picks > 0) return picks;
      return parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
    }

    // Variant id of the pre-priced bundle product for this tier (₹999 / ₹1,799 /
    // ₹2,499). When present the cart gets ONE line at that price and the flavours
    // travel as line-item properties, so no discount has to fire.
    function bundleVariantFor(bundle) {
      if (!bundle) return 0;
      return parseInt(bundle.getAttribute('data-bundle-variant'), 10) || 0;
    }

    // Does this bundle tier hand out a flavour-carrying free pack (the 3-pack's
    // free 4th box)? Read from the shared AquonBundleFreebies tier config.
    function tierHasFlavorPack(bundleVid) {
      if (!bundleVid) return false;
      var tiers = (window.AquonBundleFreebies && window.AquonBundleFreebies.tiers) || [];
      for (var i = 0; i < tiers.length; i++) {
        if (String(tiers[i].bundle) === String(bundleVid) && tiers[i].flavorPack) return true;
      }
      return false;
    }
    // The Free Pack of 24's ₹0 variant matching a picked flavour name. That
    // variant carries the correct flavour title + image everywhere natively.
    function freePackVariantForFlavour(name) {
      var map = (window.AquonBundleFreebies && window.AquonBundleFreebies.freePackByFlavour) || {};
      return map[name] || null;
    }

    // Turn the chosen flavours into line-item properties. Names are visible in
    // the cart; the `_variant_<id>` keys are hidden (leading underscore) and tell
    // fulfilment exactly which packs to pick.
    function flavorProperties(picks) {
      var props = {};
      picks.forEach(function (p) {
        props[p.name] = String(p.qty);
        props['_variant_' + p.variantId] = String(p.qty);
      });
      return props;
    }

    // The flavour currently selected on the page. The active tile is switched
    // synchronously on click (before the product fetch resolves), so it is the
    // most reliable source; the CTA attribute is only a fallback for contexts
    // that render no flavour row.
    function currentFlavorName() {
      var active = sec.querySelector('[data-apdp-flavor].is-active');
      var fromTile = active && active.getAttribute('data-flavor-name');
      return fromTile || cta.getAttribute('data-product-title') || 'Flavour';
    }

    // The free-gift lines unlocked by the current tier, at ₹0.
    function giftItems() {
      var items = [];
      sec.querySelectorAll('[data-apdp-freebie]').forEach(function (f) {
        if (f.classList.contains('is-disabled')) return;
        var fvid = parseInt(f.getAttribute('data-freebie-variant'), 10);
        if (fvid) items.push({ id: fvid, quantity: 1, properties: { _gift: 'true' } });
      });
      return items;
    }

    function openFlavorModal() {
      if (!flavorModal) return false;
      // Sync required total to the selected bundle's flavour-pick count. This is
      // NOT the same as data-quantity: the 3-pack is 3 paid packs + 1 free, so
      // the buyer picks 4 flavours while the tier's quantity is 3.
      var submit = flavorModal.querySelector('[data-apdp-flavor-submit]');
      var target = flavorModal.querySelector('[data-apdp-flavor-target]');
      var picks = flavorPicksFor(selectedBundle);
      if (submit && picks > 0) submit.setAttribute('data-total', picks);
      if (target && picks > 0) target.textContent = picks;
      flavorModal.hidden = false;
      flavorModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      // Reset all steppers on open
      flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
        var q = card.querySelector('[data-apdp-flavor-qty]');
        if (q) q.textContent = '0';
        card.classList.remove('is-selected');
      });
      // Pre-select the current product's flavour card (qty = 1) so the counter
      // starts at "1 of N" and the user only picks the remaining N-1 flavours.
      var current = flavorModal.querySelector('[data-apdp-flavor-card][data-is-current="true"]');
      if (current) {
        var cq = current.querySelector('[data-apdp-flavor-qty]');
        if (cq) cq.textContent = '1';
        current.classList.add('is-selected');
      }
      updateFlavorCount();
      return true;
    }
    function closeFlavorModal() {
      if (!flavorModal) return;
      flavorModal.hidden = true;
      flavorModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
    function updateFlavorCount() {
      if (!flavorModal) return;
      var total = 0;
      flavorModal.querySelectorAll('[data-apdp-flavor-qty]').forEach(function (q) {
        total += parseInt(q.textContent, 10) || 0;
      });
      var countEl = flavorModal.querySelector('[data-apdp-flavor-count]');
      if (countEl) countEl.textContent = total;
      var submit = flavorModal.querySelector('[data-apdp-flavor-submit]');
      var required = submit ? parseInt(submit.getAttribute('data-total'), 10) || 3 : 3;
      // Disable "+" once required total is reached
      flavorModal.querySelectorAll('[data-apdp-flavor-inc]').forEach(function (b) {
        b.disabled = total >= required;
      });
      if (submit) submit.disabled = total !== required;
    }
    if (flavorModal) {
      flavorModal.querySelectorAll('[data-apdp-flavor-close]').forEach(function (el) {
        el.addEventListener('click', closeFlavorModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !flavorModal.hidden) closeFlavorModal();
      });
      flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
        var qtyEl = card.querySelector('[data-apdp-flavor-qty]');
        var inc = card.querySelector('[data-apdp-flavor-inc]');
        var dec = card.querySelector('[data-apdp-flavor-dec]');
        function syncSelected() {
          var n = parseInt(qtyEl.textContent, 10) || 0;
          card.classList.toggle('is-selected', n > 0);
        }
        if (inc) inc.addEventListener('click', function () {
          var n = parseInt(qtyEl.textContent, 10) || 0;
          qtyEl.textContent = n + 1;
          syncSelected();
          updateFlavorCount();
        });
        if (dec) dec.addEventListener('click', function () {
          var n = parseInt(qtyEl.textContent, 10) || 0;
          if (n > 0) qtyEl.textContent = n - 1;
          syncSelected();
          updateFlavorCount();
        });
      });
      var submitBtn = flavorModal.querySelector('[data-apdp-flavor-submit]');
      if (submitBtn) submitBtn.addEventListener('click', function () {
        var picks = [];
        flavorModal.querySelectorAll('[data-apdp-flavor-card]').forEach(function (card) {
          var q = parseInt(card.querySelector('[data-apdp-flavor-qty]').textContent, 10) || 0;
          var vid = parseInt(card.getAttribute('data-variant-id'), 10);
          if (q > 0 && vid) {
            var nameEl = card.querySelector('[data-apdp-flavor-name]');
            picks.push({
              variantId: vid,
              qty: q,
              name: nameEl ? nameEl.textContent.trim() : 'Flavour ' + vid,
            });
          }
        });
        if (!picks.length) return;

        var items = [];
        var bundleVid = bundleVariantFor(selectedBundle);
        // If this tier hands out a flavour free pack (the 3-pack's free 4th box),
        // peel one box off the picks; it becomes its own ₹0 line as the matching
        // Free Pack of 24 flavour variant, so the right flavour title + image show
        // everywhere. The bundle line then carries the remaining boxes.
        var freePick = null;
        if (tierHasFlavorPack(bundleVid) && bundleVid && picks.length) {
          var lastPick = picks[picks.length - 1];
          freePick = { variantId: lastPick.variantId, name: lastPick.name };
          lastPick.qty -= 1;
          if (lastPick.qty <= 0) picks.pop();
        }
        if (bundleVid) {
          // One pre-priced bundle line; the flavours ride along as properties.
          items.push({ id: bundleVid, quantity: 1, properties: flavorProperties(picks) });
          if (freePick) {
            var freePackVid = freePackVariantForFlavour(freePick.name);
            if (freePackVid) {
              // The variant IS the flavour, so no extra flavour property is needed.
              items.push({ id: parseInt(freePackVid, 10), quantity: 1, properties: { _gift: 'true' } });
            }
          }
        } else {
          // Legacy fallback: add each chosen flavour as its own cart line.
          picks.forEach(function (p) {
            items.push({ id: p.variantId, quantity: p.qty });
          });
        }
        items = items.concat(giftItems());
        if (!items.length) return;
        submitBtn.classList.add('is-loading');
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            submitBtn.classList.remove('is-loading');
            if (!res.ok) {
              showToast((res.d && res.d.description) || 'Could not add to cart', true);
              return;
            }
            closeFlavorModal();
            // 2/3-pack adds finish in the modal, so the CTA never showed a
            // confirmation. Mirror the single-pick feedback here too.
            showAdded();
            afterAdd(flavorFlowOrigin);
          })
          .catch(function () {
            submitBtn.classList.remove('is-loading');
            showToast('Something went wrong', true);
          });
      });
    }

    // Add to cart
    if (cta) {
      var span = cta.querySelector('.apdp__cta-text');
      if (span) cta.dataset.originalLabel = span.textContent.trim();
      cta.addEventListener('click', function () {
        // Read and immediately reset the origin, so a later direct click on this
        // button is never mistaken for a sticky-bar one.
        var origin = addOrigin;
        addOrigin = 'main';
        // Tiers that need more than one flavour open the picker. A single-pick
        // tier uses the flavour already selected on the page, so no modal.
        if (flavorModal && flavorPicksFor(selectedBundle) > 1 && openFlavorModal()) {
          flavorFlowOrigin = origin;
          return;
        }
        var vid = cta.getAttribute('data-variant-id');
        if (!vid) {
          showToast('Please pick a variant', true);
          return;
        }

        var linkOverride = selectedBundle ? selectedBundle.getAttribute('data-link') : null;
        if (linkOverride) {
          window.location.href = linkOverride;
          return;
        }

        var items = [];
        var bundleVid = bundleVariantFor(selectedBundle);
        if (bundleVid) {
          // One pre-priced bundle line carrying the on-page flavour.
          items.push({
            id: bundleVid,
            quantity: 1,
            properties: flavorProperties([
              {
                variantId: parseInt(vid, 10),
                qty: 1,
                name: currentFlavorName(),
              },
            ]),
          });
        } else {
          // Legacy fallback: N x the flavour product.
          var qty = 1;
          if (selectedBundle) {
            var q = parseInt(selectedBundle.getAttribute('data-quantity'), 10);
            if (!isNaN(q) && q > 0) qty = q;
          }
          items.push({ id: parseInt(vid, 10), quantity: qty });
        }
        items = items.concat(giftItems());

        cta.classList.add('is-loading');
        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            cta.classList.remove('is-loading');
            if (!res.ok) {
              showToast((res.d && res.d.description) || 'Could not add to cart', true);
              return;
            }
            showAdded();
            afterAdd(origin);
          })
          .catch(function () {
            cta.classList.remove('is-loading');
            showToast('Something went wrong', true);
          });
      });
    }

    // ── Judge.me badge wording ───────────────────────────────────────────
    // Show "4.85/5 (678)" instead of the app's "678 reviews", built from the
    // rating and count Judge.me itself puts on the badge, so the numbers stay
    // real. The app rewrites this badge on load and again on every flavour
    // change, and it reports the average as "5.00" one time and "5" the next,
    // so watch the container and normalise rather than formatting once.
    (function initJudgemeText() {
      var wrap = sec.querySelector('[data-apdp-jdgm]');
      if (!wrap) return;
      function format() {
        var badge = wrap.querySelector('.jdgm-prev-badge');
        var textEl = wrap.querySelector('.jdgm-prev-badge__text');
        if (!badge || !textEl) return;
        var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
        if (!count) return; // no reviews yet: leave the app's own wording alone
        var avg = parseFloat(badge.getAttribute('data-average-rating'));
        if (isNaN(avg)) return;
        var out = avg.toFixed(2).replace(/\.00$/, '') + '/5 (' + count + ')';
        // Bail when it already reads correctly, so writing the text cannot
        // retrigger this observer indefinitely.
        if (textEl.textContent.trim() === out) return;
        textEl.textContent = out;
      }
      format();
      if (window.MutationObserver) {
        new MutationObserver(format).observe(wrap, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    })();

    // ── Sticky bottom bar (desktop PDP) ──────────────────────────────────
    // A pure mirror of this section's purchase state. It owns no state: the
    // title, image, tier name, prices and CTA label/classes are copied from
    // the existing PDP elements, and its button simply proxies the main CTA
    // (same flavour modal, same cart payload, same quick-cart behaviour).
    (function initStickyBar() {
      var bar = sec.querySelector('[data-apdp-sticky]');
      if (!bar || !cta) return;
      var sTitle = bar.querySelector('[data-apdp-sticky-title]');
      var sSub = bar.querySelector('[data-apdp-sticky-sub]');
      var sPrice = bar.querySelector('[data-apdp-sticky-price]');
      var sCompare = bar.querySelector('[data-apdp-sticky-compare]');
      var sDisc = bar.querySelector('[data-apdp-sticky-discount]');
      var sImg = bar.querySelector('[data-apdp-sticky-img]');
      var sCta = bar.querySelector('[data-apdp-sticky-cta]');
      var sCtaText = bar.querySelector('[data-apdp-sticky-cta-text]');

      function textOf(el) { return el ? el.textContent.trim() : ''; }

      function syncSticky() {
        if (sTitle) sTitle.textContent = textOf(titleEl) || sTitle.textContent;
        // Thumb = the selected tier's pack image (the bundle card img, which
        // already carries the per-flavour custom.bundle_image_<n>_pack
        // metafield source and is swapped on flavour change). Falls back to
        // the main gallery image when a tier has no card image.
        var tierImg = selectedBundle ? selectedBundle.querySelector('[data-apdp-bundle-img]') : null;
        var srcEl = tierImg && tierImg.src ? tierImg : sec.querySelector('[data-apdp-main]');
        if (sImg && srcEl && srcEl.src && sImg.src !== srcEl.src) {
          sImg.src = srcEl.src;
          sImg.removeAttribute('srcset');
        }
        var b = selectedBundle;
        if (b) {
          if (sSub) sSub.textContent = b.getAttribute('data-name') || '';
          if (sPrice) sPrice.textContent = textOf(b.querySelector('.apdp__bundle-price'));
          if (sCompare) sCompare.textContent = textOf(b.querySelector('.apdp__bundle-price-old'));
          var d = textOf(b.querySelector('.apdp__bundle-discount'));
          if (sDisc) { sDisc.textContent = d; sDisc.hidden = !d; }
        } else {
          // No bundle tiers configured: fall back to the variant price row.
          if (sSub) sSub.textContent = '';
          if (sPrice) sPrice.textContent = textOf(priceEl);
          if (sCompare) sCompare.textContent = textOf(compareEl);
          if (sDisc) sDisc.hidden = true;
        }
        if (sCtaText) {
          var label = textOf(cta.querySelector('.apdp__cta-text'));
          if (label) sCtaText.textContent = label;
        }
        if (sCta) {
          sCta.classList.toggle('is-loading', cta.classList.contains('is-loading'));
          sCta.classList.toggle('is-added', cta.classList.contains('is-added'));
        }
      }

      // One rAF-debounced observer on the purchase column covers every change
      // path (tier click, flavour swap fetch, CTA label/state) without adding
      // per-control listeners. The bar lives outside the column, so syncing
      // never re-triggers the observer.
      var rightCol = sec.querySelector('.apdp__right');
      var queued = false;
      function queueSync() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; syncSticky(); });
      }
      if (rightCol && window.MutationObserver) {
        new MutationObserver(queueSync).observe(rightCol, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          // 'src': the bundle-card pack images swap on flavour change and the
          // bar thumb mirrors the selected tier's image.
          attributeFilter: ['class', 'src'],
        });
      }
      // The main gallery lives in the left column and its image swaps after
      // the flavour fetch - watch it too so the bar thumb never lags a flavour
      // behind.
      var gallery = sec.querySelector('.apdp__gallery') || sec.querySelector('.apdp__left');
      if (gallery && window.MutationObserver) {
        new MutationObserver(queueSync).observe(gallery, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['src'],
        });
      }

      // Proxy the main CTA so the flavour modal, cart payload and freebies stay
      // one implementation; the flag tells that handler the add started here, so
      // it refreshes the cart in place instead of opening the quick cart.
      if (sCta) sCta.addEventListener('click', function () {
        addOrigin = 'sticky';
        cta.click();
      });

      // Visible immediately on PDP load (desktop and mobile) - no scroll gate.
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');

      syncSticky();
    })();
  }

  function initAll() {
    document.querySelectorAll('[data-apdp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-apdp]').forEach(initSection);
  });
})();

/* Accordion (Details / Delivery & Return style). Smooth height, one open at a
   time. Independent of the bundle logic above. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAcc(root) {
    if (root.dataset.apdpAccInit === '1') return;
    root.dataset.apdpAccInit = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.apdp__acc-item'));
    function panelOf(item) { return item.querySelector('[data-apdp-acc-panel]'); }
    function headOf(item) { return item.querySelector('[data-apdp-acc-head]'); }

    function close(item, animate) {
      var head = headOf(item), panel = panelOf(item);
      if (!head || head.getAttribute('aria-expanded') !== 'true') return;
      head.setAttribute('aria-expanded', 'false');
      if (reduce || !animate) { panel.style.height = '0px'; return; }
      panel.classList.add('is-anim');
      panel.style.height = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
      panel.style.height = '0px';
    }
    function open(item) {
      var head = headOf(item), panel = panelOf(item);
      head.setAttribute('aria-expanded', 'true');
      if (reduce) { panel.style.height = 'auto'; return; }
      panel.classList.add('is-anim');
      panel.style.height = panel.scrollHeight + 'px';
      var done = function (e) {
        if (e.propertyName !== 'height') return;
        if (head.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    }

    items.forEach(function (item) {
      var head = headOf(item);
      if (!head) return;
      head.addEventListener('click', function () {
        var isOpen = head.getAttribute('aria-expanded') === 'true';
        items.forEach(function (other) { if (other !== item) close(other, true); });
        if (isOpen) close(item, true); else open(item);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-apdp-acc]').forEach(initAcc); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-apdp-acc]').forEach(initAcc);
  });
})();
